import {
    IonButton,
    IonButtons,
    IonCard,
    IonContent,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";

import { Location } from "../../../@types/location";
import { RootState } from "../../../store/rootReducer";
import { setDeselectAll, setDeselectLocation } from "../../../store/userProfileLocation";
import { selectLocationsSelected } from "../../../store/userProfileLocation/selector/selectLocationsSelected";
import { ConfirmButton } from "./ConfirmButton";
import { LocationSelectedSearchBar } from "./LocationSelectedSearchBar";

export const LocationsSelected = () => {
    const dispatch = useDispatch();
    const selectedLocations = useSelector((state: RootState) => state.userProfileLocation.selectedLocations);
    const locations = useSelector(selectLocationsSelected);
    const findProfileLocationStatus = useSelector((state: RootState) => state.userProfileLocation.findProfileLocationsStatus)
 
    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar color="primary">
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Seleccionados ({selectedLocations.length})
                </IonTitle>
                <IonButtons slot="end">
                    {!!selectedLocations.length && (
                        <IonButton
                            fill="solid"
                            color="danger"
                            onClick={() => {
                                dispatch(setDeselectAll());
                            }}
                            size="small"
                        >
                            <small>Quitar todos</small>
                            <IonIcon icon={trashOutline} slot="end" />
                        </IonButton>
                    )}
                    <ConfirmButton />
                </IonButtons>
            </IonToolbar>
            <LocationSelectedSearchBar />
            <IonContent style={{ overlay: "scroll", height: "60vh" }}>
                <IonList>
                    {findProfileLocationStatus === "succeeded" && locations.map((location: Location) => (
                        <IonItem key={location.id}>
                            <IonLabel>
                                <h2 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{location.name}</IonText>
                                </h2>
                                <h4>
                                    <IonText color="medium" style={{ fontWeight: 500 }}>
                                        {location.code}
                                    </IonText>
                                </h4>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setDeselectLocation(location));
                                }}
                                size="large"
                            >
                                <IonIcon icon={trashOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {findProfileLocationStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
            </IonContent>
        </IonCard>
    );
};